import {OnDestroy} from '@angular/core/core';

import { Component, ViewEncapsulation } from '@angular/core';

import { TestService } from './../../../../../test/service/test.service';


@Component({
  selector: 'kt-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnDestroy {

 
	constructor(
    private subHederService : TestService
  ) { }
  

  ngOnDestroy(): void {
    this.subHederService.reset();
  }

  

}
